const Aggression = require("../../entities/Aggression")
const {Age}  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Raid extends Aggression {
    constructor(age) {
        super(
            age,
            AggessionNames.Raid,
            Raid.GetActionCount(age),
            Raid.GetCardText(age),
            {
                //effect
            }
        )
    }

    static GetActionCount(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 1;
            case Age.Age2:
                return 2;
            case Age.Age3:
                return 3;
        }
    }

    static GetBuildingOptions(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return [1, 1, 0, 0];
            case Age.Age2:
                return [2, 2, 1, 0];
            case Age.Age3:
                return [2, 2, 2, 1];
        }
    }
    

    static GetCardText(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return "Destroy one of your rival's age A or age I urban buildings. You gain resources equal to half its cost, rounded up."
            case Age.Age2:
                return "Destroy up to 2 of your rival's urban buildings: one of age II or older and one of age I or older. You gain resources equal to half their total cost, rounded up."
            case Age.Age3:
                return "Destroy up to 2 of your rival's urban buildings: one of age III or older and one of age II or older. You gain resources equal to half their total cost, rounded up."
        }
    }
}

module.exports = Raid;